import React from "react";
import {Button} from "antd";
import {AndroidFilled, CloseOutlined, DownloadOutlined} from "@ant-design/icons";
import {motion} from "framer-motion";
import AppEntity from "../../types/AppEntity";
import downloadApp from "../../services/DownloadApp";
import {formatBytes} from "../../services/Helpers";
import styles from "./AppAdvertising.module.css";

interface AppAdvertisingProps {
    app?: AppEntity
    onClose: () => void
}

export function AppAdvertising({app, onClose}: AppAdvertisingProps) {
    if (!app) {
        return null;
    }
    return (
        <motion.aside
            className={styles.label}
            aria-label="Get the App Repo Android app"
            initial={{y: "100%"}}
            animate={{y: 0}}
            transition={{duration: 0.24, ease: [0.16, 1, 0.3, 1]}}
        >
            <div className={styles.text}>
                <span className={styles.title}><AndroidFilled aria-hidden/> Get the Android app</span>
                <span className={`${styles.meta} mono`}>{app.version} · {formatBytes(app.fileSize)}</span>
            </div>
            <Button type="primary" icon={<DownloadOutlined/>} onClick={() => downloadApp(app)} className={styles.download}>
                Install
            </Button>
            <Button type="text" icon={<CloseOutlined/>} onClick={onClose} aria-label="Dismiss" className={styles.close}/>
        </motion.aside>
    );
}
